import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

const serverError = 'Server error';

@Injectable()
export class HttpService {
    constructor(private http: Http) {
    }
    getAll(url: any) {
        return this.http.get(url, this.getJwt()).map((response: Response) => {
            if (response.status < 200 || response.status >= 300) {
                return [];
            } else {
                return response.json();
            }
        })
            .catch((error: any) => Observable.throw(error.json().status || serverError));
    }
    private getJwt() {
        const token = localStorage.getItem('id_token');
        if (token) {
            const headers = new Headers({ 'Authorization': 'Bearer' + token });
            return new RequestOptions({ headers: headers });
        }
    }
    getById(url: any) {
        return this.http.get(url, this.getJwt()).map((response: Response) => {
            if (response.status < 200 || response.status >= 300) {
                return [];
            } else {
                return response.json();
            }
        })
            .catch((error: any) => Observable.throw(error.json().error || serverError));
    }

    create(url: any, data: any) {
        return this.http.post(url, data, this.getJwt()).map((response: Response) => response)
            .catch((error: any) => Observable.throw(error.json().error || serverError));
    }
    update(url: any, data: any) {
        return this.http.put(url, data, this.getJwt()).map((response: Response) => response)
            .catch((error: any) => Observable.throw(error.json().error || serverError));
    }
    delete(url: any) {
        return this.http.delete(url, this.getJwt()).map((response: Response) => response);
    }


}




// WEBPACK FOOTER //
// ./src/app/shared/services/http.service.ts